import { render, staticRenderFns } from "./ItemsSliderWithTitle.vue?vue&type=template&id=5fcd6c5d"
import script from "./ItemsSliderWithTitle.vue?vue&type=script&lang=ts"
export * from "./ItemsSliderWithTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports